import { db } from './firebase';
import { collection, query, getDocs, doc, updateDoc } from 'firebase/firestore';
import { User } from '../types';

export const profileService = {
  fetchProfiles: async (): Promise<User[]> => {
    const q = query(collection(db, "users"));
    const querySnapshot = await getDocs(q);
    return querySnapshot.docs.map((doc) => ({ 
      uid: doc.id,  // Changed from id to uid
      ...doc.data() 
    } as User));
  },

  sendMatchRequest: async (userId: string, matchId: string, currentMatches: string[]) => {
    const userRef = doc(db, "users", userId);
    await updateDoc(userRef, { 
      matches: [...currentMatches, matchId] 
    });
  }
};